import { Component, Input, OnInit, ViewChild, OnDestroy, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ServicesProvider } from 'src/providers/services';
import { CommonService } from 'src/providers/common';
import { AlertController, LoadingController, ModalController, ToastController, IonContent, Platform } from '@ionic/angular';
import { DatePipe, formatDate } from '@angular/common';
import { DatePikerPage } from '../date-piker/date-piker.page';
import { DoctorServiceListPage } from '../doctor-service-list/doctor-service-list.page';
import { FileUploadService } from 'src/providers/upload';
import { MediapopupPage } from '../mediapopup/mediapopup.page';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { PopupalertPage } from '../popupalert/popupalert.page';
import { AddmemPage } from '../addmem/addmem.page';
import { AddCall } from 'src/providers/addvCall';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { SuccessPage } from '../success/success.page';

@Component({
  selector: 'app-doc-appointment',
  templateUrl: './doc-appointment.page.html',
  styleUrls: ['./doc-appointment.page.scss'],
})
export class DocAppointmentPage implements OnInit, OnDestroy {
  private apiSubscriptions: Subscription[] = [];
  @ViewChild(IonContent) ionContent: IonContent;
  DoctorDetails: any = [];
  doctorId: any;
  appointmentTypeId: any;
  DropDown = [];
  PatientProDet = [];
  rescheduleId: any;
  @Input() docdetails: any;
  rate: any;
  AlertInfoDate: any;
  playVid: any;
  playMode: boolean;
  muteMode: boolean;
  storedPath: null;
  fromDocList: boolean;
  fromReschedule: boolean;

  popUp: boolean;
  clickOnlineOrClinic: boolean;

  onlineGrey: boolean;
  onlineGreen: boolean;

  homeGrey: boolean;
  homeGreen: boolean;

  directGrey: boolean;
  directGreen: boolean;

  bookedStatus: any;
  fromTime: any;

  patientName: any;
  patientResName: any;
  currentDate: string;
  clinicId: any;
  toTime: any;
  myServices: any;
  isVip: any;
  MembersList: boolean;
  reschedulePatName: boolean;
  bookingId: any;
  searchDate: any;
  serviceDuration: any;
  getMemName: any;
  getMemGender: any;
  getMemDob: any;
  getMemReletion: any;
  getMemHeight: any;
  getMemWeight: any;
  getMemMobileNo: any;
  selectSlotIndex: any = null;
  selectedDate: any;
  Date: any;
  getReviewCommands: any;
  profileMediaDetails: any = [];
  currentVideoId: any;
  currentVideoIndex: any;
  storeSlots = [];
  selectedMemberId: any;
  slotDuration: any;
  ServiceList = [];
  isServ: boolean;
  serviceName: any;
  servImg: any;
  servCost: any;
  servOff: string;
  servDesc: any;
  servicesID: string;
  memProImg: string;
  doctorName: string;
  dAmt: any;
  isShow: boolean;
  searchRequest: any;
  mediaReq: any;
  commentlength: number;
  lattitude: number;
  longititude: number;
  membDOB: any;
  reschDate: any;
  reschFTym: any;
  reschTTym: any;
  speciality: any; referalId: any;
  refEvent: any;
  getSlotReq: any;
  getPatProReq: any;
  addMemReq: any;
  getServListReq: any;
  @ViewChild('nameInput', { static: false }) input: any;
  availDate: any;
  nextAvailableDate: string;
  Gender: string;
  searchCont: any;
  fromPage: string;
  PaymentStatusRe: any;
  Email: any;
  Phoneno: any;
  vendor_splamount: any;
  vendor_spldeal: any;



  public language: string;
  globalization: any;
  final_amount: any;
  slotBookSold: boolean = false;
  firsttime: string;
  firsttimesecond: string;
  secondtime: string;
  timesecond: any;
  thirdtime: string;
  APServiceCost: any;
  reScheduledappointmentTypeId: any;
  isSlotDatas: any = [];
  defaultImage = 'assets/img/Vector.png';
  MaleImage = 'assets/newIcons/MaleJpg.jpg';
  FemaleImage = 'assets/newIcons/FeMaleJpg.jpg';
  LocationIcon: any;
  specialityType: any;
  btnSubmit: any;

  constructor(
    public activeRoute: ActivatedRoute,
    public router: Router,
    private services: ServicesProvider,
    public toastCtrl: ToastController,
    private datePipe: DatePipe,
    public modalCtrl: ModalController,
    public fileupload: FileUploadService,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    public geolocation: Geolocation,
    public addCall: AddCall,
    private platform: Platform,
  ) { }

  private common = CommonService;

  ngOnInit() {
    this.slotDuration = "00:00";
    this.serviceDuration = {
      hr: 0,
      min: 0
    }
  }

  ngOnChanges() {
    console.log(this.docdetails, "from lab page doc detaul")
    this.doctorName = this.docdetails.DoctorName;
    this.clinicId = this.docdetails.ClinicId;
    this.frmpage = 'referral';
    this.searchDate = formatDate(new Date(), 'yyyy-mmm-dd', 'en-us');
    this.myServices = "";
    this.specialityId = this.docdetails.speciality_id;
    this.specialityname = this.docdetails.speciality_name;
    this.doctorId = this.docdetails.doctor_id;
  }

  ionViewWillLeave() {
    this.selectSlotIndex = null;
    window.localStorage["isRev"] = "";
    this.common.videoSound = false;
  }
  reschtype: any;
  specialityId: any;
  specialityname: any;
  frmpage: any;
  PaymentType: any;
  alreadyPaied: any;
  isAndroid: any = null;
  isIos: any = null;
 

  ionViewWillEnter() {
    this.btnSubmit = true;
    this.isAndroid = null;
    this.isIos = null;
    if (this.platform.is("ios")) {
      console.log("ios")
      this.isIos = 1
    } else if (this.platform.is("android")) {
      this.isAndroid = 1
    }

    this.isSlotDatas = [];

    this.common.videoSound = false;
    this.common.setDoctorDetails(false);
    console.log(this.common.videoSound, "VideoSound");
    this.slotDuration = "00:00";
    this.addCall.changeDateLan(new Date());
    this.vendor_splamount = null;
    this.vendor_spldeal = null;
    this.nxtdate = true
    this.TotalAmount = [];
    this.finalamount = null;
    this.myServices = "";
    this.myServices = this.activeRoute.snapshot.paramMap.get('serviceTypeId');
    this.reschtype = this.activeRoute.snapshot.paramMap.get('ServiceName');
    this.specialityId = this.activeRoute.snapshot.paramMap.get('splid');
    this.specialityname = this.activeRoute.snapshot.paramMap.get('specialityName');
    this.PaymentType = this.activeRoute.snapshot.paramMap.get('paymenttype');
    this.alreadyPaied = this.activeRoute.snapshot.paramMap.get('book_amount');
    this.APServiceCost = this.activeRoute.snapshot.paramMap.get('APServiceCost');
    this.patientName = this.activeRoute.snapshot.paramMap.get('patientName');
    this.specialityType = this.activeRoute.snapshot.paramMap.get('specialityType');
    this.referalId = this.activeRoute.snapshot.paramMap.get('doc_referalId') || "";
    window.localStorage['alreadypaid'] = this.alreadyPaied;
    console.log(this.activeRoute.snapshot.paramMap.get('paymenttype'), "================================><><");
    this.addCall.changeDateLan(new Date());

    console.log(this.reschtype, "================");
    console.log(this.specialityId, "========spiid");
    console.log(this.specialityname, "=========");


    console.log("Service ID -----> ", this.myServices);
    this.isShow = true;
    this.serviceName = "";
    this.fromPage = localStorage.getItem("fromPage");
    if (this.fromPage == "reschedule") {
      this.MembersList = false;
      this.reschedulePatName = true;
      this.fromDocList = false;
      this.fromReschedule = true;
      this.clickOnlineOrClinic = false;
      this.getPatientProDet();
      this.patientResName = this.activeRoute.snapshot.paramMap.get('patientName');
    } else if (this.fromPage == "newBooking") {
      this.MembersList = true;
      this.selectSlotIndex = null;
      this.fromTime = null;
      this.reschedulePatName = false;
      this.fromReschedule = false;
      this.fromDocList = true;
      this.clickOnlineOrClinic = false;
      this.getPatientProDet();
    } else if (this.fromPage == "speciality") {
      this.MembersList = true;
      this.selectSlotIndex = null;
      this.fromTime = null;
      this.reschedulePatName = false;
      this.fromReschedule = false;
      this.fromDocList = true;
      this.clickOnlineOrClinic = false;
      this.searchCont = this.activeRoute.snapshot.paramMap.get('searchCont');
      this.getPatientProDet();
    }
    else if (this.fromPage == "referral") {
      this.reschedulePatName = true;
      this.patientResName = this.activeRoute.snapshot.paramMap.get('patientName');
    }
    this.popUp = false;

    //Events...
    this.Gender = this.activeRoute.snapshot.paramMap.get('Gender');

    this.selectedMemberId = this.activeRoute.snapshot.paramMap.get('selectdMemId');
    this.searchDate = this.activeRoute.snapshot.paramMap.get('searchDate');
    this.reschDate = this.activeRoute.snapshot.paramMap.get('reschDate');
    this.Date = this.activeRoute.snapshot.paramMap.get('avlDate');
    console.log("Date -> ", this.Date);
    this.fromTime = this.activeRoute.snapshot.paramMap.get('fromTime');
    this.toTime = this.activeRoute.snapshot.paramMap.get('toTime');
    let convert = this.searchDate.split("-");
    this.Date = new Date(convert[0], (convert[1] - 1), convert[2]);
    this.bookingId = this.activeRoute.snapshot.paramMap.get('bookingId');
    this.doctorName = window.localStorage['docName'];
    this.isVip = this.activeRoute.snapshot.paramMap.get('isVip');
    this.bookedStatus = this.activeRoute.snapshot.paramMap.get('bookedStatus');
    this.clinicId = this.activeRoute.snapshot.paramMap.get('clinicId');
    this.frmpage = this.activeRoute.snapshot.paramMap.get('frm');
    if (this.frmpage == 'referral') {
      this.doctorName = this.activeRoute.snapshot.paramMap.get('docname');
    }
    this.doctorId = this.activeRoute.snapshot.paramMap.get('doctorId');
    this.appointmentTypeId = this.activeRoute.snapshot.paramMap.get('appointmentTypeId');
    this.reScheduledappointmentTypeId = this.activeRoute.snapshot.paramMap.get('appointmentTypeId');
    this.reschFTym = this.activeRoute.snapshot.paramMap.get('reschFTym');
    this.reschTTym = this.activeRoute.snapshot.paramMap.get('reschTTym');
    if (this.specialityname == null) {
      this.specialityname = this.activeRoute.snapshot.paramMap.get('specialityName');
    }
    console.log(this.specialityname);

    console.log(this.activeRoute.snapshot.paramMap.get('specialityName'), 'speciality===========>');

    this.getServiceList(this.searchDate);
    this.getSlots();
    // if (this.platform.is("ios")) {
      try {
        let options = {
          enableHighAccuracy: true,
          timeout: 5000
        };
        this.geolocation.getCurrentPosition(options).then((resp) => {
          this.LocationIcon = true;
          this.lattitude = resp.coords.latitude;
          this.longititude = resp.coords.longitude;
          this.getDocDetails(1);
        }, err => {
          this.LocationIcon = false;
          this.lattitude = 29.62107798734671;
          this.longititude = 47.587719496877924;
          this.getDocDetails(1);
          console.log('Error getting location', err);
        });
      } catch (e) {
        console.log(e);
      }
  //  } 
    
    
    // else if (this.platform.is("android")) {
    //   this.lattitude = this.common.androidLatitude ?? 29.62107798734671;
    //   this.longititude = this.common.androidLongitude ?? 47.587719496877924;
    //   this.getDocDetails(1);
    // }

    if (this.fromTime) {
      this.clickOnlineOrClinic = true;
    }
  }
  
 onImageErrors(event: Event,value:any): void {
    if(value == 'Male'){
      const imgElement = event.target as HTMLImageElement;
      imgElement.src = this.MaleImage;
    }else if(value == 'Female'){
      const imgElement = event.target as HTMLImageElement;
      imgElement.src = this.FemaleImage;
    }
    else if(value == 'Vector'){
      const imgElement = event.target as HTMLImageElement;
      imgElement.src = this.defaultImage;
    }
  }

  doRefresh(event) {
    this.refEvent = event;
    this.ionViewWillEnter();
  }
  refFunc() {
    if (this.refEvent) {
      this.refEvent.target.complete();
    }
  }

  async presentToast(msg) {
    const toast = await this.toastCtrl.create({
      message: msg, duration: 2000, cssClass: 'myToastStyleSmall',
    });
    toast.present();
  }

  async AlertInfo(msg, status) {
    const alert = await this.modalCtrl.create({
      component: PopupalertPage,
      cssClass: this.addCall.selectedLanguage == 'ea' ? 'arab_alert' : 'class_alert1',
      backdropDismiss: false,
      componentProps: {
        'msg': msg,
        'sts': status,
        'dts': this.AlertInfoDate
      }
    });
    await alert.present();
    alert.onDidDismiss()
      .then((data) => {
        if (data.data == 200) {
          this.checkDealAvailable(this.AlertInfoDate);
        }
      });
  }

  checkDealAvailable(AlertInfoDate) {
    let getDate = new Date(AlertInfoDate);
    let searchDate = getDate.getFullYear() + "-" + ("0" + (getDate.getMonth() + 1)).slice(-2) + "-" + ("0" + (getDate.getDate())).slice(-2);
    this.dAmt = ""
    this.servOff = "";
    window.localStorage['dealAmt'] = this.dAmt;
    window.localStorage['dealOptn'] = "";
    let requestdata = JSON.stringify({
      "doctor_id": this.doctorId,
      "service_id": this.myServices,
      "searchDate": searchDate
    });

    const checkdoctordealavailable = this.services.postRequest("checkdoctordealavailable", requestdata).subscribe(res => {
      if (res.data.length > 0) {
        const unique = [...new Map(this.ServiceList.map((m) => [m.id, m])).values()];
        console.log(unique, 'U')
        this.ServiceList = unique

        for (let item of this.ServiceList) {
          if (this.myServices == item.id) {

            this.isServ = true;

            this.myServices = item.id;
            this.serviceName = item.service;
            this.slotDuration = item.slot_duration;
            this.servImg = item.file_path;


            this.servCost = item.cost;
            window.localStorage['servCost'] = this.servCost;
            window.localStorage['paydec'] = null;
            if (this.reschtype == 'true' && this.PaymentType == 1) {
              this.TotalAmount.push(this.servCost)

              if (this.TotalAmount.length == 2) {
                this.finalamount = this.TotalAmount.reduce((a, b) => a - b);
                window.localStorage['finalamount'] = Math.abs(this.finalamount);
              }
              else {
                window.localStorage['finalamount'] = 0;
              }

              console.log(this.TotalAmount);
              console.log(this.finalamount, "===========");

              if (this.finalamount > 0) {
                console.log('c1');
                window.localStorage['paydec'] = false;
              }
              else if (this.finalamount <= 0) {
                console.log('c2');
                window.localStorage['paydec'] = true;
              }

              console.log(window.localStorage['paydec']);

            }
            this.servDesc = item.description;

            let dOpt = res.data[0].deal_options;
            this.dAmt = res.data[0].deal_amount;
            if (dOpt == "Amount") {
              this.servOff = res.data[0].deal_amount + " KWD OFF";
            } else if (dOpt == "Percentage") {
              this.servOff = res.data[0].deal_amount + "% OFF";
            } else {
              this.servOff = "";
            }

            if (dOpt == "Amount") {
              this.final_amount = item.cost - res.data[0].deal_amount;
            }
            else if (dOpt == "Percentage") {
              this.final_amount = item.cost - (item.cost * res.data[0].deal_amount) / 100;
            }

            window.localStorage['dealOptn'] = dOpt;
            window.localStorage['dealAmt'] = this.dAmt;
            window.localStorage['dealID'] = item.dealid;
            console.log("Service ID -----> ", this.myServices);
            console.log(window.localStorage['dealID'], "====================");
          }
        }
      } else {
        window.localStorage['dealID'] = "null";
      }
    });
    this.apiSubscriptions.push(checkdoctordealavailable);
  }

  uploadPhoto() {
    this.fileupload.getFiles("2").then(async data => {
      if (data[0] == "0") {
        const toast = await this.toastCtrl.create({
          message: data[1],
          duration: 2000
        });
        toast.present();
      } else {
        console.log(data[0]);
        this.memProImg = URL.createObjectURL(data[0]);
      }
    });
  }

  async openDatePicker() {
    const datePickerModal = await this.modalCtrl.create({
      component: DatePikerPage,
      cssClass: 'datePicker',
      componentProps: {
        'selectedDate': this.selectedDate,
        curdate: new Date().toString().split(' ')[0] + ", " + new Date().toString().split(' ')[1] + " " + new Date().toString().split(' ')[2]
      }
    });
    await datePickerModal.present();

    datePickerModal.onDidDismiss()
      .then((data) => {
        if (data.data) {
          this.Date = data.data
          this.searchDate = this.Date.getFullYear() + "-" + ("0" + (this.Date.getMonth() + 1)).slice(-2) + "-" + ("0" + (this.Date.getDate())).slice(-2);
          this.getDocDetails(2);
          console.log("Service ID -----> ", this.myServices);
          this.getSlots();
          this.addCall.changeDateLan(this.Date);
        }
      });
  }

  async openDatePicker2() {
    const datePickerModal = await this.modalCtrl.create({
      component: DatePikerPage,
      cssClass: 'datePicker',
      componentProps: {
        'selectedDate': this.selectedDate,
        'calenderType': "dob"
      }
    });
    await datePickerModal.present();

    datePickerModal.onDidDismiss()
      .then((data) => {
        if (data.data) {
          let date = data.data
          this.getMemDob = this.getFormattedDateTime(date, "Date");
          this.membDOB = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + (date.getDate())).slice(-2);
        }
      });
  }

  makeLike(i, docId, isLyk) {
    try {
      if (this.DoctorDetails[i].favourite == null) {
        this.DoctorDetails[i].favourite = "false";
      } else if (this.DoctorDetails[i].favourite == "false") {
        this.DoctorDetails[i].favourite = "true";
      } else if (this.DoctorDetails[i].favourite == "true") {
        this.DoctorDetails[i].favourite = "false";
      }

      if (this.DoctorDetails[i].isLiked == null) {
        this.DoctorDetails[i].isLiked = "true";
        this.DoctorDetails[i].likes_count = Number(this.DoctorDetails[i].likes_count) + 1;
      } else if (this.DoctorDetails[i].isLiked == "false") {
        this.DoctorDetails[i].isLiked = "true";
        this.DoctorDetails[i].likes_count = Number(this.DoctorDetails[i].likes_count) + 1;
      } else if (this.DoctorDetails[i].isLiked == "true") {
        this.DoctorDetails[i].isLiked = "false";
        this.DoctorDetails[i].likes_count = Number(this.DoctorDetails[i].likes_count) - 1;
      }

      let data = JSON.stringify({
        "vendor_id": docId,
        "like": isLyk,
        "user_id": localStorage.getItem("patient_id"),
        "module_name": "Doctor",
      });
      const UpdateVendorLikes = this.services.postRequestDoc("UpdateVendorLikes", data).subscribe(res => {
        console.log(res);
      }, (err) => {
        console.log(err);
      });
      this.apiSubscriptions.push(UpdateVendorLikes);
    } catch (err) {
      console.log(err);
    }
  }

  like(doctorId) {
    console.log("doc ID=>", doctorId);

    if (this.DoctorDetails[0].favourite == null) {
      this.DoctorDetails[0].favourite = false;
    }

    this.DoctorDetails[0].favourite = !this.DoctorDetails[0].favourite;
    let apiData = JSON.stringify({
      "doctorId": doctorId,
      "patientId": localStorage.getItem("patient_id"),
      "favourite": this.DoctorDetails[0].favourite
    });
    const favouriteDoctorAddingandRemoving = this.services.postRequest("favouriteDoctorAddingandRemoving", apiData).subscribe(res => {
    });
    this.apiSubscriptions.push(favouriteDoctorAddingandRemoving);
    if (this.DoctorDetails[0].favourite == true) {
      this.presentToast("Add to Favourite");
    }
    else if (this.DoctorDetails[0].favourite == false) {
      this.presentToast("Removed from Favourite");
    }
  }

  getFormattedDateTime(dateTime, callFor) {
    if (!dateTime) {
      return "";
    }

    let Value;
    switch (callFor) {
      case "Time":
        if (dateTime.indexOf("T") > -1) {
          Value = dateTime.split("T")[1];
        } else if (dateTime.indexOf(" ") > -1) {
          Value = dateTime.split(" ")[1];
        } else {
          Value = dateTime;
        }
        let hourEnd = Value.indexOf(":");
        let H = +String(Value).substr(0, hourEnd);
        let h = H % 12 || 12;
        let ampm = (H < 12 || H === 24) ? "am" : "pm";
        let timeString = h + String(Value).substr(hourEnd, 3) + " " + ampm;
        return timeString;
      case "Date":
        if (this.addCall.selectedLanguage == 'en') {
          return this.datepipeTransform(new Date(dateTime), "dd-MMM-yy");
        } else {
          let dateCall = new Date(dateTime);
          let months = ["يناير", "فبراير", "مارس", "إبريل", "مايو", "يونيو",
            "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
          ];
          let day = String(dateCall.getDate()).padStart(2, '0');
          let arDate = day + '-' + months[dateCall.getMonth()] + '-' + dateCall.getFullYear().toString().substr(-2);
          return arDate;
        }
      case "DateTime":
        return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy h:mm a");
      case "Date1":
        if (this.addCall.selectedLanguage == 'en') {
          return this.datepipeTransform(new Date(dateTime), "dd-MMM-yy");
        } else {
          let dateCall = new Date(dateTime);
          let months = ["يناير", "فبراير", "مارس", "إبريل", "مايو", "يونيو",
            "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
          ];
          let day = String(dateCall.getDate()).padStart(2, '0');
          let arDate = day + '-' + months[dateCall.getMonth()] + '-' + dateCall.getFullYear().toString().substr(-2);
          return arDate;
        }
    }

  }

  datepipeTransform(date: any, format: string): any {
    return this.datePipe.transform(date, format);
  }

  nxtdate: boolean = true;

  dateIncDec(incOrDec) {
    this.showalert = false;
    this.availDate = null;
    if (incOrDec == 'inc') {
      this.nxtdate = true;
      let date = new Date(this.Date);
      date.setDate(date.getDate() + 1);
      this.Date = date;
      this.searchDate = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + (date.getDate())).slice(-2);
      this.getDocDetails(3);
      this.getServiceList(this.searchDate);
      console.log("Service ID -----> ", this.myServices);
      this.getSlots();
    }
    else if (incOrDec == 'dec') {
      var currentDate = new Date().getFullYear() + "-" + ("0" + (new Date().getMonth() + 1)).slice(-2) + "-" + ("0" + (new Date().getDate())).slice(-2);
      if (this.fristslot.length == 0) {
        var fristslot = new Date()
      }
      else if (this.fristslot.length > 0 && this.searchDate != currentDate) {
        fristslot = new Date(this.Date)
        fristslot.setDate(fristslot.getDate() - 1);
      }

      console.log(new Date(this.Date.toString()), "========date", fristslot);
      if (new Date(this.Date.toString()) > fristslot) {
        let date = new Date(this.Date);
        date.setDate(date.getDate() - 1);
        this.Date = date;
        this.searchDate = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + (date.getDate())).slice(-2);

        this.getDocDetails(4);
        this.getServiceList(this.searchDate);

        console.log("Service ID -----> ", this.myServices);
        this.nxtdate = false;
        this.getSlots();
      }
    }
    this.addCall.changeDateLan(this.Date);
  }

  backToSpecialityDocListHead() {
    if (localStorage.getItem("fromPage") == "newBooking") {
      this.router.navigate(['/tabs/doctors-list', { id: localStorage.getItem("specId"), Gender: this.Gender}]);
    } else if (localStorage.getItem("fromPage") == "reschedule") {
      this.router.navigate(['/tabs/appointments']);
    } else if (localStorage.getItem("fromPage") == "newBookingDirectSlotClick") {
      this.router.navigate(['/tabs/doctors-list', { id: localStorage.getItem("specId") }]);
    } else if (localStorage.getItem("fromPage") == "speciality") {
      this.router.navigate(['/tabs/speciality', {
        searchCont: this.searchCont, specialityType: this.specialityType
      }]);
    }
    else if (localStorage.getItem("fromPage") == 'referral') {
      this.router.navigate(['/tabs/appointments', { frmPage: 'referral' }]);
    }
    else if (localStorage.getItem("fromPage") == 'labreferral') {
      console.log('back to lab');
      this.router.navigate(['/tabs/appointments', { frmPage: 'labreferral' }]);
    }

    //Events........
    this.popUp = false;
    this.clickOnlineOrClinic = false;
  }

  openBookingConfirmation(clinicName,clinicAddress,clinicLatLong) {
    if (this.isSlotDatas.length != 0) {
      if (this.myServices != null) {
        window.localStorage['partDocDet'] = JSON.stringify(this.DoctorDetails);
        localStorage.setItem("patientName", this.patientName);
        if (this.fromPage == "reschedule") {
          localStorage.setItem("patientName", this.patientResName);
        }
        this.router.navigate(['/tabs/booking-conf', {
          doctorId: this.doctorId,
          appointmentTypeId: this.appointmentTypeId,
          clinicId: this.clinicId,
          fromTime: this.fromTime,
          toTime: this.toTime,
          reschFTym: this.reschFTym,
          reschTTym: this.reschTTym,
          isVip: this.isVip,
          myServices: this.myServices,
          bookingId: this.bookingId,
          doctorProfile: this.DoctorDetails[0].doctorProfileImage,
          bookDate: this.searchDate,
          reschDate: this.reschDate,
          selectdMemId: this.selectedMemberId ? this.selectedMemberId : "",
          searchCont: this.searchCont,
          Gender: this.Gender,
          splid: this.specialityId,
          speciname: this.specialityname,
          email: ((this.Email != '') && (this.Email != null) && (this.Email != undefined)) ? this.Email : localStorage.getItem('Email'),
          phone: this.Phoneno,
          paymenttype: this.PaymentType,
          frmreschedule: this.reschtype,
          alreadyPaied: this.alreadyPaied,
          specialamount: this.vendor_splamount,
          specialdeal: this.vendor_spldeal,
          referal_id: this.referalId,
          APServiceCost: this.APServiceCost,
          isSlotDatas: this.isSlotDatas,
          patientName: this.patientName,
          clinicName: clinicName,
          clinicAddress: clinicAddress,
          clinicLatLong: clinicLatLong,
          LocationIcon:this.LocationIcon
        }]);
        this.clickOnlineOrClinic = false;
        this.popUp = false;
      } else {
        this.presentToast("Select Service");
      }
    } else {
      this.presentToast("Please select the slot");
    }
  }

  async addMembers1() {
    const modal = await this.modalCtrl.create({
      component: AddmemPage,
      cssClass: 'Add-Member-Page',
      componentProps: {
        getMemName: "",
        getMemGender: "",
        getMemReletion: "",
        getMemHeight: "",
        getMemWeight: "",
        getMemMobileNo: "",
        membDOB: "",
        getMemDob: "",
        memProImg: ""
      },
    });
    modal.onDidDismiss()
      .then((data) => {
        const res = data;
        console.log(res);
        if (res.data.from == 2) {
          this.getPatientProDet();
        }
      });
    return await modal.present();
  }

  backToBookingConf1() {
    this.popUp = false;
  }



  //---------Events.......................

  hidePopUpOnline() {
    this.appointmentTypeId = 2;
    setTimeout(() => {
      this.popUp = false;
      this.ionContent.scrollToBottom(500);
    }, 500);
    this.clickOnlineOrClinic = true;

    this.onlineGrey = false;
    this.onlineGreen = true;

    this.homeGrey = true;
    this.directGrey = true;
    this.homeGreen = false;
    this.directGreen = false;
  }
  hidePopUpHome() {
    this.appointmentTypeId = 5;
    setTimeout(() => {
      this.popUp = false;
    }, 500);
    this.clickOnlineOrClinic = true;

    this.homeGrey = false;
    this.homeGreen = true;

    this.onlineGrey = true;
    this.directGrey = true;
    this.onlineGreen = false;
    this.directGreen = false;
  }
  hidePopUpClinic() {
    this.appointmentTypeId = 1;
    setTimeout(() => {
      this.popUp = false;
      this.ionContent.scrollToBottom(500);
    }, 500);
    this.clickOnlineOrClinic = true;

    this.directGrey = false;
    this.directGreen = true;

    this.onlineGrey = true;
    this.homeGrey = true;
    this.onlineGreen = false;
    this.homeGreen = false;
  }
  dismisspopup() {
    this.selectSlotIndex = null;
    this.fromTime = null;
    setTimeout(() => {
      this.popUp = false;
    }, 500);
  }

  //-------------------------------------


  //API Integration events.............
  selectedClinic(ftime, tTime, status, dayId, appointmentTypeId, index) {

    this.isSlotDatas = [];
    this.isSlotDatas.push(this.doctorId, this.clinicId, this.myServices, this.currentDate, ftime, tTime, dayId, appointmentTypeId);
    if (this.reschtype != "true") {
      console.log("Appointment Type ID -> ", appointmentTypeId);
      console.log("Service ID -> ", this.myServices);
      let requestdata = JSON.stringify({
        "doctorId": this.doctorId,
        "patientId": localStorage.getItem("patient_id"),
        "clinicId": this.clinicId,
        "serviceId": this.myServices,
        "bookingDate": this.currentDate,
        "fromTime": ftime,
        "toTime": tTime,
        "dayId": dayId,
        "appointtypeId": appointmentTypeId,
        "paymentStatus": 0,
      });
      const isSlotBooked = this.services.postRequest("isSlotBooked", requestdata).subscribe(response => {
        debugger;
        if (response.status == 1) {
          if (this.myServices) {
            debugger;
            this.fromTime = ftime;
            this.toTime = tTime;
            this.appointmentTypeId = appointmentTypeId;
            if (this.appointmentTypeId == 3) {
              this.isVip = 1;
            } else {
              this.isVip = 0;
            }
            this.selectSlotIndex = index;
            if (status != true && appointmentTypeId == 4) {
              this.popUp = true;
            }
            else if (status != true && appointmentTypeId != 4) {
              this.clickOnlineOrClinic = true;
            }
            else {
              this.clickOnlineOrClinic = false;
            }

            this.onlineGrey = true;
            this.onlineGreen = false;
            this.homeGrey = true;
            this.homeGreen = false;
            this.directGrey = true;
            this.directGreen = false;

            setTimeout(() => {
              this.ionContent.scrollToBottom(500);
            }, 500);
          } else {
            this.presentToast("Select Services");
          }
        } else {
          this.presentToast(response.msg);
        }
      });
      this.apiSubscriptions.push(isSlotBooked);
    }
    else {
      if (this.reschtype == "true" && this.reScheduledappointmentTypeId == String(3) && appointmentTypeId != 3) {
        this.presentToast("Please select  Fast Track Appointment");
      }
      else if (this.reschtype == "true" && this.reScheduledappointmentTypeId != String(2)) {
        console.log("Appointment Type ID -> ", appointmentTypeId);
        console.log("Service ID -> ", this.myServices);
        if (this.myServices) {
          this.fromTime = ftime;
          this.toTime = tTime;
          this.appointmentTypeId = appointmentTypeId;
          if (this.appointmentTypeId == 3) {
            this.isVip = 1;
          } else {
            this.isVip = 0;
          }
          this.selectSlotIndex = index;
          if (status != true && appointmentTypeId == 4) {
            this.popUp = true;
          }
          else if (status != true && appointmentTypeId != 4) {
            this.clickOnlineOrClinic = true;
          }
          else {
            this.clickOnlineOrClinic = false;
          }

          this.onlineGrey = true;
          this.onlineGreen = false;
          this.homeGrey = true;
          this.homeGreen = false;
          this.directGrey = true;
          this.directGreen = false;

          setTimeout(() => {
            this.ionContent.scrollToBottom(500);
          }, 500);
        } else {
          this.presentToast("Select Services");
        }
      }
      else if (this.reschtype == "true" && this.reScheduledappointmentTypeId == String(2) && (appointmentTypeId == 2 || appointmentTypeId == 4)) {
        console.log("Appointment Type ID -> ", appointmentTypeId);
        console.log("Service ID -> ", this.myServices);
        if (this.myServices) {
          this.fromTime = ftime;
          this.toTime = tTime;
          this.appointmentTypeId = 2;
          this.selectSlotIndex = index;
          this.clickOnlineOrClinic = true;
          setTimeout(() => {
            this.ionContent.scrollToBottom(500);
          }, 500);
        } else {
          this.presentToast("Select Services");
        }
      } else if (this.reschtype == "true" && this.reScheduledappointmentTypeId == String(2) && appointmentTypeId != 2) {
        this.presentToast("Please select  Online Appointment");

      }
    }
  }
  selectMember(value, membId) {
    this.patientName = value;
    this.selectedMemberId = String(membId);
  }
  isBooked(data) {
    if (data == 1) {
      return true;
    } else {
      return false;
    }
  }


  focusName() {
    let _obj = this;
    setTimeout(() => {
      _obj.input.nativeElement.focus();
    });
  }

  //API Integration....................
  getDocDetails(frm) {

    this.vendor_splamount = null;
    this.vendor_spldeal = null;
    console.log(frm);
    try {
      if (this.searchRequest) {
        this.searchRequest.unsubscribe();
      }
      this.DoctorDetails = [];
      this.profileMediaDetails = [];
      let getDate = new Date();
      this.currentDate = getDate.getFullYear() + "-" + ("0" + (getDate.getMonth() + 1)).slice(-2) + "-" + ("0" + (getDate.getDate())).slice(-2);
      let requestdata = JSON.stringify({
        "doctorId": this.doctorId,
        "clinicId": this.clinicId,
        "lat": this.lattitude,
        "long": this.longititude,
        "patientId": localStorage.getItem("patient_id"),
        "currentDate": this.currentDate,
        "searchDate": this.searchDate,
        "current_time": new Date().toTimeString().split(" ")[0]
      });
      this.searchRequest = this.services.postRequest("particularDoctorDetails", requestdata).subscribe(response => {
        console.log(response);
        this.common.setDoctorDetails(response.data[0]);
        this.DoctorDetails.push(response.data[0]);
        console.log(response.data[0].special_vendorAmount);
        if (response.data[0]?.special_vendorAmount != null) {
          this.vendor_splamount = response.data[0]?.special_vendorAmount.split(',')[0];
          this.vendor_spldeal = response.data[0]?.special_vendorAmount.split(',')[1]
        }
        console.log(response.data[0].review_comment, "==========")
        if (response.data[0].review_comment) {

          if (frm == 1) {
            if (window.localStorage["isRev"] == "rating") {
              this.isShow = false;
              this.getReviewCommands = JSON.parse(this.DoctorDetails[0].review_comment);

            } else {
              this.isShow = true;
              this.getReviewCommands = JSON.parse(this.DoctorDetails[0].review_comment)[0];

            }
          } else {
            this.isShow = true;
            this.getReviewCommands = JSON.parse(this.DoctorDetails[0].review_comment)[0];
          }
          this.commentlength = JSON.parse(this.DoctorDetails[0].review_comment).length;
        } else {
          this.getReviewCommands = [];
          this.commentlength = 0;
        }
        console.log("Review Comments - ", this.getReviewCommands);
        this.refFunc();
      }, err => {
        console.log(err);
        this.refFunc();
      });
      this.apiSubscriptions.push(this.searchRequest);
      this.getMedia();
    } catch (err) {
      console.log(err);
      this.refFunc();
    }
  }

  fristslot: any = [];
  showalert: boolean = false;

  getSlots() {
    console.log('==----------------======')
    console.log(this.nxtdate, "======");
    this.storeSlots = [];
    try {

      if (this.myServices) {
        this.storeSlots = [];
        if (this.getSlotReq) {
          this.getSlotReq.unsubscribe();
        }
        let apiData = JSON.stringify({
          "doctor_id": Number(this.doctorId),
          "clinic_id": this.clinicId,
          "service_id": this.myServices,
          "search_date": this.searchDate,
          "type": "",
          "nxtdate": this.nxtdate

        });
        this.getSlotReq = this.services.postRequestDoc("getslotsbyservice", apiData).subscribe(res => {
          console.log("Slots Details ---> ", res);
          if (this.availDate != res.data[0].available_date) {
            this.availDate = res.data[0].available_date;
          } else {
            this.availDate = ""
          }

          let splt = this.getFormattedDateTime(this.availDate, 'Date').split(" ")
          let date = splt[0] + " " + splt[1];
          this.nextAvailableDate = date;

          for (let i of res.data[0]?.date_slots) {
            const currentTime = moment();

            let slotdate = i.date
            let slottime = i.from_time
            let givenTime = moment(String(slotdate) + 'T' + String(slottime))

            if (givenTime.isAfter(currentTime) == true && i.is_blocked == 0 && i.is_booked == 0) {
              this.storeSlots.push(i)
            }

          }
          console.log(this.availDate.length, "check");
          console.log(this.storeSlots.length, "slots");
          console.log(this.showalert, "alert");

          if (this.availDate.length > 0 && this.storeSlots.length == 0) {
            this.goToNextAvail()
          }

          if (this.nxtdate == false && this.storeSlots.length > 0 && new Date().toDateString() != new Date(res.data[0].date).toDateString() && this.showalert == true) {  
            this.AlertInfoDate = this.getFormattedDateTime(res.data[0].date, 'Date')
            this.AlertInfo(this.addCall.title279, 8);
          }
          else if (this.nxtdate == true && this.storeSlots.length > 0 && new Date().toDateString() != new Date(res.data[0].date).toDateString() && this.showalert == true) {  
            if (this.fristslot.length == 0) {
              this.fristslot.push(res.data[0].date)
            }
            this.AlertInfoDate = this.getFormattedDateTime(res.data[0].date, 'Date')
            this.AlertInfo(this.addCall.title278, 8);
          }
        }, (err) => {
          console.log(err);
        });
        this.apiSubscriptions.push(this.getSlotReq);
      } else {
        this.storeSlots = [];
      }
    } catch (err) {
      console.log(err);
    }
  }


  getMedia() {
    let tempArr = [];
    if (this.mediaReq) {
      this.mediaReq.unsubscribe();
    }
    this.profileMediaDetails = [];
    let apiData2 = JSON.stringify({
      "doctorId": Number(this.doctorId),
      "limit": 1000,
      "pageno": 1
    });
    this.mediaReq = this.services.postRequest("getMediaDetailsByDoctor", apiData2).subscribe(res => {
      console.log("mediaDetails=>", res);
      for (let item of res.data[0].details) {
        tempArr.push(item);
        if (tempArr.length == 3) {
          this.profileMediaDetails.push(JSON.parse(JSON.stringify(tempArr)));
          tempArr = [];
        }
      }
      if (tempArr.length > 0) {
        this.profileMediaDetails.push(JSON.parse(JSON.stringify(tempArr)));
      }
    });
    this.apiSubscriptions.push(this.mediaReq);
  }

  getPatientProDet() {
    if (this.getPatProReq) {
      this.getPatProReq.unsubscribe();
    }
    let getDate = new Date();
    this.currentDate = getDate.getFullYear() + "-" + ("0" + (getDate.getMonth() + 1)).slice(-2) + "-" + ("0" + (getDate.getDate())).slice(-2);
    let time = new Date(Date.now()).toLocaleTimeString();
    let requestdata = JSON.stringify({
      "patientId": localStorage.getItem("patient_id"),
      "currentDate": this.currentDate,
      "currentTime": time
    });
    this.getPatProReq = this.services.postRequest("getPatientProfile", requestdata).subscribe(response => {
      console.log("Patient Profile Details -> ", response);
      this.PatientProDet = response.data;
      this.patientName = response.data[0].name;
      this.selectedMemberId = response.data[0].patientId
      this.Email = response.data[0].email;
      this.Phoneno = response.data[0].phone_no;
    });
    this.apiSubscriptions.push(this.getPatProReq);
  }

  insertMemberDetails() {
    console.log(
      this.memProImg,
      this.getMemName,
      this.getMemGender,
      this.getMemReletion,
      this.getMemHeight,
      this.getMemWeight,
      this.getMemMobileNo,
      this.getMemDob);
    if (
      this.memProImg != null &&
      this.getMemName != null &&
      this.getMemGender != null &&
      this.getMemReletion != null &&
      this.getMemHeight != null &&
      this.getMemWeight != null &&
      this.getMemMobileNo != null &&
      this.getMemDob != null) {
      this.insertMember();
    }
    else {
      let value = [
        {
          "f_Name": "Select Photo",
          "f_value": this.memProImg
        },
        {
          "f_Name": "Enter Name",
          "f_value": this.getMemName
        },
        {
          "f_Name": "Choose Gender",
          "f_value": this.getMemGender
        },
        {
          "f_Name": "Select Date Of Birth",
          "f_value": this.getMemDob
        },
        {
          "f_Name": "Choose Reletion",
          "f_value": this.getMemReletion
        },
        {
          "f_Name": "Enter Height",
          "f_value": this.getMemHeight
        },
        {
          "f_Name": "Enter Weight",
          "f_value": this.getMemWeight
        }, {
          "f_Name": "Enter Mobile No",
          "f_value": this.getMemMobileNo
        }];
      console.log("Value=>", value);
      for (let item of value) {
        if (item.f_value == null) {
          this.presentToast("Please " + item.f_Name);
          break;
        }
      }
    }
  }

  async insertMember() {
    if (this.addMemReq) {
      this.addMemReq.unsubscribe();
    }
    const loading = await this.loadingCtrl.create({
      message: 'Loading...',
    });
    await loading.present();
    let apiData = JSON.stringify({
      "parentpatientId": localStorage.getItem("patient_id"),
      "patientId": 0,
      "imagearray": this.fileupload.getfilepath1(),
      "name": this.getMemName,
      "gender": this.getMemGender,
      "dob": this.membDOB,
      "relationId": this.getMemReletion,
      "heightcm": this.getMemHeight,
      "weightkg": this.getMemWeight,
      "phoneno": this.getMemMobileNo,
      "modifiedby": localStorage.getItem("patient_id")
    });
    this.addMemReq = this.services.postRequest("addPatientmemberDetails", apiData).subscribe(async res => {
      await loading.dismiss();
      if (res.status == 1) {
        this.AlertInfo(this.addCall.title280, res.status);

        //Events...
        this.popUp = false;
        this.getPatientProDet();
      }
    });
    this.apiSubscriptions.push(this.addMemReq);
  }


  async selectService() {
    if(this.btnSubmit == true ){
      this.btnSubmit = false;
      console.log(this.ServiceList);
      window.localStorage['docID'] = this.doctorId;
      let popover = await this.modalCtrl.create({
        component: DoctorServiceListPage,
        cssClass: 'service-model',
        componentProps: {
          ServiceList: this.ServiceList,
        }
      });
      popover.onDidDismiss()
        .then((data) => {
          if (data.data.id != "") {
            this.btnSubmit = true;
            this.myServices = data.data.id;
            this.fromTime = "";
            this.toTime = "";
            this.selectSlotIndex = null;
            this.clickOnlineOrClinic = false;
            let getDate = new Date(this.searchDate);
            this.searchDate = getDate.getFullYear() + "-" + ("0" + (getDate.getMonth() + 1)).slice(-2) + "-" + ("0" + (getDate.getDate())).slice(-2);
  
            console.log("Service ID -----> ", this.myServices);
  
            if (this.reschtype == 'true' && this.PaymentType == 1) {
              if (this.TotalAmount.length == 2) {
                this.TotalAmount.pop()
                this.finalamount = 0;
              }
            }
  
            setTimeout(() => {
              this.ionContent.scrollToBottom(500);
            }, 500);
            this.serviceVald();
          }else{
            this.btnSubmit = true;
          }
        });
  
  
      return await popover.present();
    }
  }

  TotalAmount: any = [];
  finalamount: any = 0;
  serviceVald() {
    console.log('check calling', this.reschtype);
    console.log(this.ServiceList);

    const unique = [...new Map(this.ServiceList.map((m) => [m.id, m])).values()];
    console.log(unique, 'U')
    this.ServiceList = unique


    if (this.ServiceList.length > 0) {

      for (let item of this.ServiceList) {
        if (this.myServices == item.id) {

          this.isServ = true;

          this.myServices = item.id;
          this.serviceName = item.service;
          this.slotDuration = item.slot_duration;
          this.servImg = item.file_path;


          this.servCost = item.cost;
          window.localStorage['servCost'] = this.servCost;
          window.localStorage['paydec'] = null;
          if (this.reschtype == 'true' && this.PaymentType == 1) {
            this.TotalAmount.push(this.servCost)

            if (this.TotalAmount.length == 2) {
              this.finalamount = this.TotalAmount.reduce((a, b) => a - b);
              window.localStorage['finalamount'] = Math.abs(this.finalamount);
            }
            else {
              window.localStorage['finalamount'] = 0;
            }

            console.log(this.TotalAmount);
            console.log(this.finalamount, "===========");

            if (this.finalamount > 0) {
              console.log('c1');
              window.localStorage['paydec'] = false;
            }
            else if (this.finalamount <= 0) {
              console.log('c2');
              window.localStorage['paydec'] = true;
            }

            console.log(window.localStorage['paydec']);

          }


          this.servDesc = item.description;

          let dOpt = item.deal_options;
          this.dAmt = item.deal_amount;
          if (dOpt == "Amount") {
            this.servOff = item.deal_amount + " KWD OFF";
          } else if (dOpt == "Percentage") {
            this.servOff = item.deal_amount + "% OFF";
          } else {
            this.servOff = "";
          }

          if (dOpt == "Amount") {
            this.final_amount = item.cost - item.deal_amount;
          }
          else if (dOpt == "Percentage") {
            this.final_amount = item.cost - (item.cost * item.deal_amount) / 100;
          }

          window.localStorage['dealOptn'] = dOpt;
          window.localStorage['dealAmt'] = this.dAmt;
          window.localStorage['dealID'] = item.dealid;
          console.log("Service ID -----> ", this.myServices);
          console.log(window.localStorage['dealID'], "====================");
        }
      }

      this.getSlots();
    }

    if (this.availDate != null) {
      console.log("Call slot");

    }

  }

  getServiceList(searchDate) {
    try {
      if (this.getServListReq) {
        this.getServListReq.unsubscribe();
      }
      this.isServ = false;
      let apiData = JSON.stringify({
        "doctor_id": this.doctorId,
        "speciality_Id": this.specialityId,
        "clinic_id": this.clinicId,
        "search_date": searchDate
      });
      this.getServListReq = this.services.postRequest("getDoctorManageServicePatient", apiData).subscribe(res => {
        this.ServiceList = res.data;
        console.log("Service ID => ", this.myServices);
        this.serviceVald();
      }, (err) => {
        console.log(err);
      });
      this.apiSubscriptions.push(this.getServListReq);
    } catch (err) {
      console.log(err);
    };
  }

  showHideRev() {
    if (this.getReviewCommands.length != 0) {
      if (this.isShow == true) {
        this.isShow = false;
        this.getReviewCommands = JSON.parse(this.DoctorDetails[0].review_comment);
      } else {
        this.isShow = true;
        this.getReviewCommands = JSON.parse(this.DoctorDetails[0].review_comment)[0];
      }
    }
  }


  async openNdPlay(type: any, path: any, mode: any, thumbnail: any) {
    debugger
    if (this.storedPath === path) {
      this.showPopover(type, path, thumbnail);
    } else {
      this.storedPath = path;
      this.showPopover(type, path, thumbnail);
    }
  }

  private async showPopover(type: any, path: any, thumbnail: any) {
    debugger
    const popover = await this.modalCtrl.create({
      component: MediapopupPage,
      componentProps: {
        Type: type,
        Path: path,
        ThumNail: thumbnail,
      },
      cssClass: 'media-popup',
    });
    await popover.present();
  }

  goToNextAvail() {
    console.log("Next Available date - ", this.availDate);
    this.Date = this.availDate;
    this.searchDate = this.availDate;
    this.getSlots();
    this.showalert = true;
  }

  noSlotcall(date) {

    if (this.storeSlots.length == 0) {
      this.AlertInfoDate = this.getFormattedDateTime(date, 'Date')
      this.AlertInfo(this.addCall.title279, 8);
      this.fristslot.push(date)
      this.Date = date;
      this.searchDate = date;
      this.getSlots();
    }
  }

  ngOnDestroy() {
    this.apiSubscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

  async OpenMapMethod(clinicname: any, clinic_address: any, clinic_lat_long: any) {
    const modal = await this.modalCtrl.create({
      component: SuccessPage,
      cssClass: 'mapmodel',
      componentProps: {
        typeValue: 33,
        clinicname: clinicname,
        clinic_address: clinic_address,
        clinic_lat_long: clinic_lat_long,
      }
    });
    modal.onDidDismiss()
    .then((data) => {
      if (data.data == "Map_Not_Show") {
         this.ionViewWillEnter();
      }
    });
    return await modal.present();
  }

}
